<template>
  <div>
    <el-table
      ref="elTableRef"
      :data="tableData"
      element-loading-text="Loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0)"
      :reserve-selection="true"
      center
      height="60vh"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :type="item.type"
        :index="item.index"
        :column-key="item.columnKey"
        :fixed="item.fixed"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :min-width="item.minWidth"
        :sortable="item.sortable"
        :resizable="item.resizable"
        :align="item.align"
        :header-align="item.headerAlign || item.align"
        :selectable="item.selectable"
      >
        <!-- 这里的template是否需要根据使用页面传过来的布尔值来判断 -->
        <template v-if="item.slotScoped" #default="scope">
          <!-- 插槽 -->
          <slot v-if="item.slotScoped" :name="item.slotScoped" :scope="scope">
            {{ scope.row[item.prop] }}
          </slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableColumns: {
      type: Array,
      default: function() {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('selection-change', val)
    }
  }
}
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/SelfEleTable.vue